<template>
  <div class="flex flex-col">
    <span class="text-avtalat-secondary">{{ label }}</span>
    <strong>{{ text }}</strong>
  </div>
</template>
<script setup lang="ts">
type LabeledTextProps = {
  label: string;
  text: string | null | undefined;
};
defineProps<LabeledTextProps>();
</script>
